import { useQuery } from '@tanstack/react-query';
import { get } from '@/lib/api-client';
import type { MediaFormat } from '@/hooks/useMediaFormats';

/**
 * Hook to fetch media format names for filter dropdowns.
 * Uses the new /api/media-formats endpoint instead of the product catalog.
 * Returns an array of media format name strings for backward compatibility
 * with queue filter dropdowns.
 */
export function useMediaTypes() {
  return useQuery({
    queryKey: ['media-formats', 'names'],
    queryFn: async () => {
      const response = await get<{
        success: boolean;
        data: { mediaFormats: MediaFormat[] };
      }>('/media-formats');
      return response.data.mediaFormats.map((f) => f.name);
    },
    staleTime: 10 * 60 * 1000, // 10 minutes — media formats rarely change
  });
}
